export function request( state ) {
    return state;
}

export function error( state ) {
    return state;
}

export function finish( state ) {
    return state;
}
